import { useEffect, useRef } from 'react';

// These inputs are uncontrolled (defaultValue + onBlur commit) so typing doesn't force a
// re-render on every keystroke. This hook keeps the DOM value in sync when `value` changes
// from outside the input itself (e.g. loading a saved query, resetting a rule).
export function useSyncedInputValue(value: string) {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current && inputRef.current.value !== value) {
            inputRef.current.value = value;
        }
    }, [value]);

    return inputRef;
}
